import { useEffect } from 'react';
import { track } from '@amplitude/analytics-browser';

import { LoanTypes } from '@api/models/account';
import { AmplitudeEvents } from '@utils/amplitudeEvents';
import { getLoanEventOptions } from './eventOptions';
import { paymentStatusRBBMapper } from '@api/models/notificationStates';
import {
	FinancingAccountV2Response,
	FinancingAccountV2ResponseStatusEnum,
} from '../../../types/generated/pos';

const LoanTypeToEvent = {
	[LoanTypes.POS]: AmplitudeEvents.POSMain_Opened,
	[LoanTypes.CASH]: AmplitudeEvents.CashloanMain_Opened,
	[LoanTypes.MOTO]: AmplitudeEvents.POSMotoMain_Opened,
};

export const useTrackLoanEvents = (loan: FinancingAccountV2Response) => {
	useEffect(() => {
		if (loan) {
			const eventOptions = getLoanEventOptions(loan);

			const amplitudeEvent = LoanTypeToEvent[loan.loanType];

			const loanType = loan.state?.type;

			if (loan.status === FinancingAccountV2ResponseStatusEnum.CLOSED) {
				track(amplitudeEvent, {
					state: paymentStatusRBBMapper.LoanClosed,
					product: eventOptions,
				});
			} else if (loanType !== undefined) {
				track(amplitudeEvent, {
					state: paymentStatusRBBMapper[loanType],
					product: eventOptions,
				});
			}
		}
	}, [loan]);
};
